
import { Vue } from "vue-class-component";

export default class SortFilter extends Vue {}
